import type { ShopSectionFilter } from "@alm/domain";
import { parseShow } from "@/routes/_authenticated/nancy/-components/graph/graph-sections";

const FOCUS = /^(product|concept):[0-9a-f-]{36}$/u;

/** "<type>:<id>": the node lit up and centred, or null for the whole picture. */
const parseFocus = (value: unknown): string | null =>
  typeof value === "string" && FOCUS.test(value) ? value : null;

/** The graph's place in a url: the node lit up and the section shown, each left off when unset. */
export function graphSearch(search: Record<string, unknown>): {
  focus?: string;
  show?: ShopSectionFilter;
} {
  const focus = parseFocus(search.focus);
  const show = parseShow(search.show);
  return { ...(focus ? { focus } : {}), ...(show ? { show } : {}) };
}
